import React, { FC } from 'react';
import ResignIcon from './ResignIcon';
import { buttonStyles, iconStyles } from './styles.css';

type GameToolButtonProps = {
  onClick?: () => void;
};

const GameToolButton: FC<GameToolButtonProps> = ({ onClick }) => (
  <button onClick={onClick} className={buttonStyles} aria-label="Resign">
    <ResignIcon className={iconStyles} />
  </button>
);

export default GameToolButton;
